@use '~@vp/swan/tokens' as *;
@use 'src/app/features/FragmentRoot/tokens';

// Local imports
@use 'src/app/features/Gallery/components/Filters/Filters';
@use 'src/app/features/Gallery/components/Footer/Faq/Faq';
@use 'src/app/features/Gallery/components/Footer/QuickLinks/QuickLinks';
@use 'src/app/features/Gallery/components/Footer/ProductOptionsDescriptions/ProductOptionsDescriptions';
@use 'src/app/features/Gallery/components/SecondaryContent/SecondaryContent';
@use 'src/app/features/Gallery/components/SetHighlighting/SetHighlighting';
@use 'src/app/features/Gallery/components/Header/HeroHeader/HeroHeader';
@use 'src/app/features/Gallery/components/Header/ActionHeader/ActionHeader';
@use 'src/app/features/Gallery/components/Subheader/Subheader';
@use 'src/app/features/Gallery/components/Pagination/Pagination';
@use 'src/app/features/Gallery/components/PreviewArea/PreviewArea';
@use 'src/app/features/Gallery/components/PreviewArea/FullBleedUploadTile/FullBleedUploadTile/FullBleedUploadTile';
@use 'src/app/features/Gallery/components/PreviewArea/CareTile/CareTile';
@use 'src/app/features/Gallery/components/DesignTile/DesignTile';
@use 'src/app/features/QuickView/QuickView';
@use 'src/app/components/LoadingSpinner/LoadingSpinner';
@use 'src/app/components/ColorSwatchPicker/ColorSwatchPicker';
@use 'src/app/features/Gallery/components/ClearAllRefinementsTextButton/ClearAllRefinementsTextButton';
@use 'src/app/components/FavoriteButton/FavoriteButton';
@use 'src/app/components/Skeleton/Skeleton';
@use 'src/app/components/PricingDisplay/PricingDisplay';
@use 'src/app/components/PreviewImage/PreviewImage';
@use 'src/app/components/Tile/Tile';
@use 'src/app/features/Gallery/components/PreviewArea/GalleryQuickView/GalleryQuickView';
@use 'src/app/features/Gallery/components/PreviouslyOrderedCallout/PreviouslyOrderedCallout';

:root {
  --default-font-size: var(--swan-font-size-2);
}

// This prevents FOUC
html {
  visibility: visible;
}

body {
  margin: $swan-sem-space-none;
  padding: $swan-sem-space-none;
  overflow-x: hidden;
}

.app {
  .left-nav-wrapper {
    display: none;
  }

  @media (tokens.$small-screens) {
    .left-nav-wrapper {
      display: block;
    }
  }

  &:has(.debug-toolbar-panel) {
    position: relative;
    margin-left: tokens.$debug-panel-width;
  }
}

.swan-site-main {
  z-index: auto;
}

.swan-site-content {
  height: 100%;
}

/* Text meant only for screen readers. */
.screen-reader-text {
  border: 0;
  clip-path: rect(1px, 1px, 1px, 1px);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  overflow-wrap: anywhere;
  word-break: normal;
}

.clickable {
  &:hover {
    cursor: pointer;
  }
}

/*
    Styles below are used to create an inner application scroll container
    that prevents iOS devices from scrolling the viewport when interacting
    with the sticky search bar.
*/
@media (tokens.$small-screen-max) {
  #root {
    height: 100%;
    width: 100%;
  }

  .site-content {
    height: 100%;
    width: 100%;
    overflow: auto;
  }

  .site-main {
    position: static;
  }

  html,
  body {
    height: 100%;
  }

  html {
    overflow: hidden;
  }

  body {
    overflow: auto;
  }
}
